<template>
  <main role="main">

    <section class="jumbotron text-center" style="width: 100%; display: flex; justify-content: center;">
      <div style="width: 90%; margin-top: -1cm">

        <div class="title1">游戏说明</div>

        <p class="lead text-muted m-3 text-left">
          从1-100之间选择您心仪的数字，第1次猜中获得200分，第2次猜中获得50分，第3次猜中获得20分，第4次猜中获得10分，第5次猜中获得5分，第6次及之后猜中扣1分。
        </p>

        <div class="title2">数字大侦探</div>

        <div>
          <el-table :data="tips">
            <el-table-column label="范围提示" prop="radius"></el-table-column>
            <el-table-column label="猜测次数" prop="count"></el-table-column>
          </el-table>
        </div>

        <hr>

        <div class="input-with-button-container">
          <!-- 输入框组件 -->
          <el-input-number v-model="queryParams.numberValue" size="medium"></el-input-number>

          <el-button type="primary" @click="startGame" size="medium">开始游戏</el-button>
        </div>

      <div>
        <p> </p>
        <hr>
        <p> </p>
      </div>


        <div class="title1">积分天梯榜 (前10)</div>
        <el-button type="primary" @click = "search" size="medium">更新排名</el-button>
        <div>
          <el-table :data="tableData">
            <el-table-column label="用户名" prop="name"></el-table-column>
            <el-table-column label="积分" prop="points"></el-table-column>
          </el-table>
        </div>
      </div>
    </section>
    <div class="album py-5 bg-light">
      <div class="container">
        <hr>

      </div>
    </div>

  </main>
</template>

<script>

  import TheCourse from "../components/the-course";
  export default {
    name: 'guess_number',
    components: {TheCourse},
    data: function () {
      return {
        tableData: [],
        tips:[],
        queryParams: {
          numberValue: 1, // 绑定到输入框的值
        }, // 用于存储查询参数的对象
      }
    },
    created() {
      let _this = this;
      _this.getPointsRanking();
    },
    methods: {

      //更新排名
      search(){
        this.getPointsRanking()
      },

      startGame(){
        let _this = this;
        let loginMember = Tool.getLoginMember();
        if (Tool.isEmpty(loginMember)) {
          Toast.warning("请先登录");

          return;
        }
        _this.queryParams.memberId = loginMember.id;
        console.log("queryParams:", _this.queryParams);
        _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/pointGame/guessNumber',
            _this.queryParams).then((response)=>{
          console.log("开始游戏：", response);
          _this.tips = response.data;
          },
        )
        },

      getPointsRanking() {
        let _this = this;
        _this.$ajax.get(process.env.VUE_APP_SERVER + '/business/web/pointGame/getPointsRanking').then((response)=>{
          console.log("积分排名：", response);
          _this.tableData = response.data;
        }).catch((response)=>{
          console.log("error：", response);
        })
      },

    }
  }
</script>

<style>
  .title1{
    margin-bottom: 2rem;
    color: #fafafa;
    letter-spacing: 0;
    text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
    font-size: 2rem;
  }
  .title2{
    margin-bottom: 2rem;
    color: transparent;
    -webkit-text-stroke: 1px black;
    letter-spacing: 0.04em;
    font-size: 2rem;
  }
  .title {
    margin-bottom: 10px;
    font-size: 30px;
    color: #333;
    text-align: center;
  }

  .input-with-button-container {
    display: flex;
    align-items: center; /* 确保元素垂直居中对齐 */
    gap: 8px; /* 在两个元素间创建2字符（可以调整为所需的像素值）的间距 */
  }
</style>
